import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";
import { FaSearch, FaTimes } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";

function AuthenticatorGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (props.filter) {
      setSearchText(props.filter.emailDomain ?? "");
    }
  }, [props.filter?.emailDomain]);

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      GridHelper.handleSearch({ emailDomain: searchText }, location, navigate);
    }
  };

  const handleSearch = () => {
    GridHelper.handleSearch({ emailDomain: searchText }, location, navigate);
  };

  const handleClear = () => {
    setSearchText("");
    props.onClearFilters();
  };

  return (
    <div className="mb-3">
      <InputGroup>
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search by email domain..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyDown={onKeyDown}
        />
        {searchText && (
          <Button variant="outline-secondary" onClick={handleClear}>
            <FaTimes />
          </Button>
        )}
        <Button variant="primary" onClick={handleSearch}>
          Search
        </Button>
      </InputGroup>
    </div>
  );
}

export default AuthenticatorGridFilter;
